import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import { CREATION_FORMATS } from "./landingCreationFormats";
import "./LandingProductDetailsSection.css";
import "./LandingCreationSection.css";

const PRODUCT_DETAILS = [
  {
    id: "scenario",
    tag: "Сценарий",
    icon: <AccountTreeOutlinedIcon />,
    title: "Интерактивное обучение: решение сотрудника меняет ход событий",
    lead: "Сотрудник не просто смотрит запись — он принимает решения, и от каждого ответа зависит, что будет дальше. Разные реакции, разные исходы — как в реальной рабочей ситуации.",
    features: [
      "Сотрудник выбирает вариант действия — сценарий реагирует по-разному",
      "Пример для продаж: менеджер общается с клиентом и одними решениями приходит к успешной сделке, другими — нет",
      "Подходит для онбординга, продаж, сервиса, compliance и отработки типовых кейсов",
      "Прохождение в Telegram или MAX — без отдельного приложения и сложной LMS",
    ],
    highlight: {
      icon: <RouteOutlinedIcon />,
      text: "HR видит, как команда проходит программу, и понимает, где люди «спотыкаются» на сложных решениях.",
    },
    accent: "scenario",
    previewEditorLabel: "Редактор сценария",
    previewBotLabel: "Как видит сотрудник в боте",
  },
  {
    id: "knowledge_base",
    tag: "База знаний",
    icon: <MenuBookOutlinedIcon />,
    title: "Карманная подсказка: как вести себя в конкретной ситуации",
    lead: "Инструкцию легко забыть, PDF не открывают, наставник не всегда рядом. В базе знаний вы фиксируете, как сотруднику действовать в той или иной ситуации — он открывает бота и сразу получает подсказку.",
    features: [
      "Ситуация и правильная реакция: например, бариста — что ответить, если гость говорит, что кофе сделан неправильно",
      "Новое оборудование: похоже на старое, но с особенностями — через базу донесёте инструкцию до всех заинтересованных сотрудников",
      "Ответ текстом или коротким видео — как удобнее объяснить",
      "HR задаёт стандарт один раз — вся команда получает одинаковую информацию",
    ],
    highlight: {
      icon: <SmartphoneOutlinedIcon />,
      text: "Не нужно искать в чатах и папках — открыл бота, выбрал ситуацию, получил подсказку.",
    },
    accent: "kb",
    previewEditorLabel: "Редактор базы знаний",
    previewBotLabel: "Как видит сотрудник в боте",
  },
  {
    id: "trainer",
    tag: "Тренажёр",
    icon: <QuizOutlinedIcon />,
    title: "Тренажёр: прокачка навыков и дополнительная мотивация",
    lead: "Инструмент помогает закрепить знания и отработать навыки на практике. Сотрудник отвечает на вопросы, сразу видит результат — а HR получает картину по команде.",
    features: [
      "Вопросы текстом или видео — проверяете то, что важно именно вашему бизнесу",
      "Мгновенная обратная связь: сразу видно, усвоил ли сотрудник тему",
      "Рейтинг и аналитика — кто лидирует, где команда ошибается чаще всего",
      "Дополнительная мотивация: ачивки за прохождение, бонусы за первые места — «занимайся, получишь приз»",
    ],
    highlight: {
      icon: <EmojiEventsOutlinedIcon />,
      text: "Лучшие в рейтинге тренажёра — повод для поощрения: ачивка, благодарность или бонус от руководителя.",
    },
    accent: "trainer",
    previewEditorLabel: "Редактор тренажёра",
    previewBotLabel: "Как видит сотрудник в боте",
  },
];

const formatPreviews = Object.fromEntries(
  CREATION_FORMATS.map((format) => [format.id, format])
);

export default function LandingProductDetailsSection() {
  return (
    <section
      id="products"
      className="landing-band landing-band--products-detail landing-section landing-section--products-detail"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="02 · Продукты"
          title="Три формата — подробнее"
          desc="Разбираем каждый инструмент на примерах из реальной работы: продажи, сервис, новое оборудование, мотивация команды."
        />

        <div className="landing-product-details">
          {PRODUCT_DETAILS.map(
            ({
              id,
              tag,
              icon,
              title,
              lead,
              features,
              highlight,
              accent,
              previewEditorLabel,
              previewBotLabel,
            }) => {
              const previews = formatPreviews[id];

              return (
                <article
                  key={id}
                  id={`product-${id}`}
                  className={`landing-product-detail landing-product-detail--${accent}`}
                >
                  <div className="landing-product-detail__head">
                    <span className="landing-product-detail__tag">{tag}</span>
                    <div className="landing-product-detail__icon">{icon}</div>
                    <h3 className="landing-product-detail__title">{title}</h3>
                    <p className="landing-product-detail__lead">{lead}</p>
                  </div>

                  <ul className="landing-product-detail__features">
                    {features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>

                  {previews ? (
                    <div className="landing-product-detail__previews">
                      <div className="landing-product-detail__preview">
                        <span className="landing-product-detail__preview-label">
                          {previewEditorLabel}
                        </span>
                        {previews.editor}
                      </div>
                      <div className="landing-product-detail__preview">
                        <span className="landing-product-detail__preview-label">
                          {previewBotLabel}
                        </span>
                        {previews.bot}
                      </div>
                    </div>
                  ) : null}

                  <div className="landing-product-detail__highlight">
                    <div className="landing-product-detail__highlight-icon">
                      {highlight.icon}
                    </div>
                    <p>{highlight.text}</p>
                  </div>
                </article>
              );
            }
          )}
        </div>
      </div>
    </section>
  );
}
